import React from 'react';
import { useSelector } from 'react-redux';

import ProblemResultCell from 'common.components/results/__problem-result-cell/results__problem-result-cell';
import TableCell from 'common.components/results/__table-cell/results__table-cell';
import { useShouldShowPastes } from 'common.components/teacher-detect-pastes';
import { StudentsResult } from 'common.components/results/typings';
import { isOpenAnswer, isRobot } from 'store/problems/utils';

import TableBlock from '../__table-block/results__table-block';
import { getStudentCommonProblems } from '../selectors';

interface Props {
    studentResult: StudentsResult;
    classId: number | null;
    onStudentNameClick: (studentId: number) => void;
    expandProblem: (problem: { problemId: number | null }) => void;
    setHoveredIndex: (index: number) => void;
    style: React.CSSProperties;
    canShowProblemsContent: boolean;
    setCellRef: (ref: HTMLDivElement | null) => void;
    shouldHideBorder: boolean;
    handleMouseTableLeave: () => void;
    tableStyle: React.CSSProperties;
}

export const ResultsTableBlockBody = ({
    studentResult,
    classId,
    onStudentNameClick,
    expandProblem,
    setHoveredIndex,
    style,
    canShowProblemsContent,
    setCellRef,
    shouldHideBorder,
    handleMouseTableLeave,
    tableStyle,
}: Props) => {
    const studentId = studentResult.studentId;

    const problems = useSelector((state) => getStudentCommonProblems(state, { studentId, classId }));

    const showPastes = useShouldShowPastes(true);

    return (
        <TableBlock hidden={shouldHideBorder} onMouseLeave={handleMouseTableLeave} style={tableStyle}>
            {problems.map((problemLink, problemIndex) => {
                const problemLinkId = problemLink.id;
                const handleCellClick = () => {
                    onStudentNameClick(studentId);
                    expandProblem({ problemId: problemLinkId });
                };

                return (
                    <TableCell
                        key={`problem-result-${problemLink.id}`}
                        onMouseEnter={() => setHoveredIndex(problemIndex)}
                        style={style}
                        type={TableCell.TYPE.PROBLEM}
                    >
                        <ProblemResultCell
                            additionalParams={{
                                isOpenAnswer: isOpenAnswer(problemLink.problem),
                                isRobot: isRobot(problemLink.problem),
                                hasPaste: showPastes && studentResult.result.problems[problemLinkId]?.cheating.pasted,
                            }}
                            cardNumber={problemIndex + 1}
                            onClick={canShowProblemsContent ? handleCellClick : undefined}
                            onMouseEnter={(ref: HTMLDivElement | null) => setCellRef(ref)}
                            problem={studentResult.result.problems[problemLinkId]}
                            problemId={problemLink.problem!.id}
                            problemLinkId={problemLinkId}
                            studentId={studentId}
                        />
                    </TableCell>
                );
            })}
        </TableBlock>
    );
};
